var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xl-4 col-lg-6 col-xs-12" },
        [
          _c(
            "form-element",
            {
              scopedSlots: _vm._u(
                [
                  _vm.$v.model.title.$dirty && _vm.$v.model.title.$invalid
                    ? {
                        key: "errors",
                        fn: function() {
                          return [
                            !_vm.$v.model.title.required
                              ? _c("required-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_Title_DisplayName"
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.model.title.maxLength
                              ? _c("max-length-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_Title_DisplayName"
                                    ),
                                    "max-length": _vm.rules.title.maxLength
                                  }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _c("label", { attrs: { for: "title" } }, [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "PushNotificationCreationModel_Title_DisplayName"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$v.model.title.$model,
                    expression: "$v.model.title.$model"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "title", type: "text" },
                domProps: { value: _vm.$v.model.title.$model },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.$v.model.title, "$model", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "form-element",
            {
              scopedSlots: _vm._u(
                [
                  _vm.$v.model.message.$dirty && _vm.$v.model.message.$invalid
                    ? {
                        key: "errors",
                        fn: function() {
                          return [
                            !_vm.$v.model.message.required
                              ? _c("required-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_Message_DisplayName"
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.model.message.maxLength
                              ? _c("max-length-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_Message_DisplayName"
                                    ),
                                    "max-length": _vm.rules.message.maxLength
                                  }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _c("label", { attrs: { for: "message" } }, [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "PushNotificationCreationModel_Message_DisplayName"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$v.model.message.$model,
                    expression: "$v.model.message.$model"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "message" },
                domProps: { value: _vm.$v.model.message.$model },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.$v.model.message,
                      "$model",
                      $event.target.value
                    )
                  }
                }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xl-4 col-lg-6 col-xs-12" },
        [
          _c(
            "form-element",
            { attrs: { icon: "far fa-bell", labelSize: 4 } },
            [
              _c("label", { attrs: { for: "type" } }, [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "PushNotificationCreationModel_Type_DisplayName"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "form-control",
                attrs: {
                  id: "type",
                  options: _vm.types,
                  clearable: false,
                  selectOnTab: true
                },
                model: {
                  value: _vm.model.type,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "type", $$v)
                  },
                  expression: "model.type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-element",
            {
              attrs: { icon: "far fa-clock", labelSize: 4 },
              scopedSlots: _vm._u(
                [
                  _vm.$v.model.expiresInMinutes.$dirty &&
                  _vm.$v.model.expiresInMinutes.$invalid
                    ? {
                        key: "errors",
                        fn: function() {
                          return [
                            !_vm.$v.model.expiresInMinutes.required
                              ? _c("required-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_ExpiresInMinutes_DisplayName"
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.model.expiresInMinutes.minValue
                              ? _c("min-value-error-message", {
                                  attrs: {
                                    "field-name": _vm.resource(
                                      "PushNotificationCreationModel_ExpiresInMinutes_DisplayName"
                                    ),
                                    "min-value":
                                      _vm.rules.expiresInMinutes.minValue
                                  }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _c("label", { attrs: { for: "expiretime" } }, [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "PushNotificationCreationModel_ExpiresInMinutes_DisplayName"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.$v.model.expiresInMinutes.$model,
                    expression: "$v.model.expiresInMinutes.$model",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "expiretime", type: "number", min: "1" },
                domProps: { value: _vm.$v.model.expiresInMinutes.$model },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.$v.model.expiresInMinutes,
                      "$model",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-xl-8 col-md-12" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right",
            class: { disabled: !_vm.isValid },
            on: { click: _vm.sendNotification }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.resource("Button_Create")) +
                "\n            "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }